import script from "./BannerCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&setup=true&lang=js"

import "./BannerCarousel.vue?vue&type=style&index=0&id=335e34b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-335e34b8"]])

export default __exports__